import { render, staticRenderFns } from "./LensMainView.vue?vue&type=template&id=31a66eb5&scoped=true"
import script from "./LensMainView.vue?vue&type=script&lang=js"
export * from "./LensMainView.vue?vue&type=script&lang=js"
import style0 from "./LensMainView.vue?vue&type=style&index=0&id=31a66eb5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31a66eb5",
  null
  
)

export default component.exports